import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "long-input q-mx-auto" }
const _hoisted_2 = { key: 0 }

import { computed } from "vue";
import { appStore, saveTeamStore, teamApiStore } from "@/hooks";
import {
  FlexBox,
  Separator,
  TextButton,
  TextInput,
  Typography,
} from "@/components/common";


/**
 * Inputs for creating a team.
 */
const __default__ = {
  name: "SaveTeamInputs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["submit"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const editedTeam = computed(() => saveTeamStore.editedTeam);

const loading = computed(() => teamApiStore.saveTeamApiLoading);

/**
 * Saves the edited team.
 */
function handleSave() {
  teamApiStore.handleSave(editedTeam.value, {
    onSuccess: () => {
      appStore.close("saveTeam");
      emit("submit");
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(saveTeamStore).isUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Typography), {
            variant: "subtitle",
            value: "Create Team"
          }),
          _createVNode(_unref(Separator), { b: "2" }),
          _createVNode(_unref(Typography), {
            secondary: "",
            value: "\n          Create a new team within this organization.\n          Teams are used to group members and projects together\n          with specific access permissions.\n        ",
            el: "p",
            b: "4"
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(TextInput), {
      modelValue: editedTeam.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedTeam.value.name) = $event)),
      label: "Team Name",
      hint: "Required",
      "data-cy": "input-org-name"
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(FlexBox), {
      "full-width": "",
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(TextButton), {
          color: "primary",
          label: "Save",
          "data-cy": "button-org-save",
          loading: loading.value,
          onClick: handleSave
        }, null, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})